var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container bairun-shift-tank-record" },
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            { attrs: { inline: true, model: _vm.searchInfo } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "选择油站" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "搜索条件" },
                      on: { change: _vm.onStationChange },
                      model: {
                        value: _vm.searchInfo.stationId,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "stationId", $$v)
                        },
                        expression: "searchInfo.stationId"
                      }
                    },
                    _vm._l(_vm.stationOptions, function(item) {
                      return _c("el-option", {
                        key: item.ID,
                        attrs: { label: item.stationName, value: item.ID }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "选择油灌" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "搜索条件" },
                      on: { change: _vm.onTankChange },
                      model: {
                        value: _vm.searchInfo.tankNum,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "tankNum", $$v)
                        },
                        expression: "searchInfo.tankNum"
                      }
                    },
                    _vm._l(_vm.stationTankOptionsTemp, function(item) {
                      return _c("el-option", {
                        key: item.tankNum,
                        attrs: {
                          label: item.oilTankName + "-" + item.oilCode + "#",
                          value: item.tankNum
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "时间范围" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      "value-format": "yyyyMMdd",
                      placeholder: "开始日期"
                    },
                    on: { change: _vm.onSubmit },
                    model: {
                      value: _vm.searchInfo.startDate,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "startDate", $$v)
                      },
                      expression: "searchInfo.startDate"
                    }
                  }),
                  _vm._v(" - "),
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      "value-format": "yyyyMMdd",
                      placeholder: "结束日期"
                    },
                    on: { change: _vm.onSubmit },
                    model: {
                      value: _vm.searchInfo.endDate,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "endDate", $$v)
                      },
                      expression: "searchInfo.endDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onExport } },
                    [_vm._v("导出")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "shiftTankRecordTable",
          staticClass: "bairun-shift-tank-table",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            "span-method": _vm.tableCellMerge
          }
        },
        [
          _c(
            "el-table-column",
            {
              attrs: { align: "center", fixed: "" },
              scopedSlots: _vm._u([
                {
                  key: "header",
                  fn: function(scope) {
                    return [
                      _c("div", { staticClass: "table-title" }, [
                        _vm._v(
                          _vm._s(_vm.searchInfo.stationName) +
                            "班结分罐保管登记帐"
                        ),
                        _c("br"),
                        _vm._v(
                          "【" +
                            _vm._s(_vm.searchInfo.tankNum) +
                            "号灌】-【" +
                            _vm._s(_vm.searchInfo.oilCode) +
                            "#】"
                        )
                      ])
                    ]
                  }
                }
              ])
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "shiftName",
                  label: "班次",
                  width: "120px",
                  fixed: ""
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "totalLastShiftLiters", label: "上班结存(L)" }
              }),
              _c("el-table-column", {
                attrs: { prop: "giveInLiters", label: "进货升数(L)" }
              }),
              _c("el-table-column", {
                attrs: { prop: "giveInTon", label: "进货吨数(t)" }
              }),
              _c("el-table-column", {
                attrs: { prop: "giveInCompareLiters", label: "罐车验收升数(L)" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "beforeOilHeight",
                  label: "油罐卸油前尺油高(mm)"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "beforeOilCapacity",
                  label: "油罐卸油前尺升数(L)"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "afterOilHeight", label: "油罐卸油后尺油高(mm)" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "afterOilCapacity",
                  label: "油罐卸油后尺升数(L)"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "sequenceOilSales",
                  label: "卸油期间发油升数(L)"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "sequenceInLiters", label: "油罐实收升数(L)" }
              }),
              _c("el-table-column", {
                attrs: { prop: "oilLossLiters", label: "验收损溢数(L)" }
              }),
              _c("el-table-column", {
                attrs: { prop: "totalOilSales", label: "销量(L)" }
              }),
              _c("el-table-column", {
                attrs: { prop: "checkTotalLastShiftLiters", label: "账存数(L)" }
              }),
              _c("el-table-column", {
                attrs: { prop: "shiftOilHeight", label: "交班液高(mm)" }
              }),
              _c("el-table-column", {
                attrs: { prop: "shiftWaterHeight", label: "交班水高(mm)" }
              }),
              _c("el-table-column", {
                attrs: { prop: "shiftOilCapacity", label: "交班库存(L)" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "cumulativeOilLossLiters",
                  label: "累计损溢量(L)"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "currentCumulativeOilLossLiters",
                  label: "当天损溢量(L)"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "tankDataImg", label: "交班液位仪拍照" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.tankDataImg != ""
                          ? _c(
                              "el-link",
                              {
                                attrs: {
                                  href: scope.row.tankDataImg,
                                  target: "_blank",
                                  type: "primary"
                                }
                              },
                              [_vm._v("点击查看")]
                            )
                          : _c("span", [_vm._v("未上传")])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "shiftNo", label: "操作", width: "130px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: {
                              size: "small",
                              disabled: scope.row.status == 3
                            },
                            on: {
                              click: function($event) {
                                return _vm.onRowEdit(scope.row)
                              }
                            }
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "提交后不能再修改",
                              placement: "top-end"
                            }
                          },
                          [
                            _c(
                              "el-popconfirm",
                              {
                                attrs: {
                                  title: "请问是否提交？提交后不能再修改"
                                },
                                on: {
                                  confirm: function($event) {
                                    return _vm.onRowSubmit(scope.row)
                                  }
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      size: "small",
                                      type: "primary",
                                      disabled: scope.row.status == 3
                                    },
                                    slot: "reference"
                                  },
                                  [_vm._v("提交")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 20, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            top: "5vh",
            width: "60%",
            title: "编辑"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.dialogClose
          }
        },
        [
          _c(
            "el-table",
            {
              staticClass: "bairun-shift-tank-update",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.updateTableData,
                border: "",
                "span-method": _vm.updateTableCellMerge
              }
            },
            [
              _c(
                "el-table-column",
                {
                  attrs: { align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function(scope) {
                        return [
                          _c("div", { staticClass: "table-title" }, [
                            _vm._v(
                              "变更 -【" +
                                _vm._s(_vm.formData.tankNum) +
                                "号灌】-【" +
                                _vm._s(_vm.formData.oilCode) +
                                "#】"
                            )
                          ])
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "shiftName", label: "班次", width: "120px" }
                  }),
                  _vm.formData.tankInNo != ""
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "giveInCompareLiters",
                          label: "罐车验收升数(L)"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("el-input", {
                                    staticClass: "paperview-input-text",
                                    attrs: { placeholder: "请填写（必填）" },
                                    nativeOn: {
                                      input: function($event) {
                                        return _vm.onInputDecimal($event)
                                      }
                                    },
                                    model: {
                                      value: scope.row.giveInCompareLiters,
                                      callback: function($$v) {
                                        _vm.$set(
                                          scope.row,
                                          "giveInCompareLiters",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "scope.row.giveInCompareLiters"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          622472220
                        )
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: { prop: "shiftOilHeight", label: "交班液高(mm)" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              staticClass: "paperview-input-text",
                              attrs: { placeholder: "请填写（必填）" },
                              nativeOn: {
                                input: function($event) {
                                  return _vm.onInputDecimal($event)
                                }
                              },
                              model: {
                                value: _vm.formData.shiftOilHeight,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "shiftOilHeight", $$v)
                                },
                                expression: "formData.shiftOilHeight"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "shiftWaterHeight", label: "交班水高(mm)" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              staticClass: "paperview-input-text",
                              attrs: { placeholder: "请填写（必填）" },
                              nativeOn: {
                                input: function($event) {
                                  return _vm.onInputDecimal($event)
                                }
                              },
                              model: {
                                value: _vm.formData.shiftWaterHeight,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "shiftWaterHeight",
                                    $$v
                                  )
                                },
                                expression: "formData.shiftWaterHeight"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "shiftOilCapacity", label: "交班库存(L)" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              staticClass: "paperview-input-text",
                              attrs: { placeholder: "请填写（必填）" },
                              nativeOn: {
                                input: function($event) {
                                  return _vm.onInputDecimal($event)
                                }
                              },
                              model: {
                                value: _vm.formData.shiftOilCapacity,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "shiftOilCapacity",
                                    $$v
                                  )
                                },
                                expression: "formData.shiftOilCapacity"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "交班液位仪拍照",
                      prop: "shiftNo",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-upload",
                              {
                                ref: "oilTankUpload" + _vm.formData.shiftNo,
                                staticClass:
                                  "shift-record-uploader bairun-required",
                                attrs: {
                                  action:
                                    _vm.path + "/fileUploadAndDownload/upload",
                                  "before-upload": _vm.uploadBefore,
                                  headers: { "x-token": _vm.token },
                                  "on-error": _vm.uploadError,
                                  "on-success": function(res, file, fileList) {
                                    _vm.uploadSuccess(
                                      res,
                                      file,
                                      fileList,
                                      _vm.formData,
                                      "tankDataImg"
                                    )
                                  },
                                  "show-file-list": false,
                                  accept: "image/*"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "el-icon-plus shift-record-uploader-icon"
                                })
                              ]
                            ),
                            _vm.formData.tankDataImg != ""
                              ? _c(
                                  "span",
                                  { staticClass: "shift-record-uploader" },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        height: "100%",
                                        width: "100%"
                                      },
                                      attrs: { src: _vm.formData.tankDataImg }
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "el-upload-list__item-actions"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "el-upload-list__item-preview",
                                            on: {
                                              click: function($event) {
                                                return _vm.handleUploadPreview(
                                                  _vm.formData,
                                                  "tankDataImg"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-zoom-in"
                                            })
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "el-upload-list__item-delete",
                                            on: {
                                              click: function($event) {
                                                return _vm.handleUploadRemove(
                                                  _vm.formData,
                                                  "tankDataImg",
                                                  "oilTankUpload" +
                                                    _vm.formData.shiftNo
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-delete"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.dialogSave } },
                [_vm._v("保存")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { top: "5vh", visible: _vm.previewDialogVisible },
          on: {
            "update:visible": function($event) {
              _vm.previewDialogVisible = $event
            }
          }
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.previewDialogImageUrl, alt: "" }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }